import React, { useState, createContext } from "react";

export const Context = createContext();
export const ContextProvider = ({ children }) => {
  const [count, setNumberAnswers] = useState(1);
  const [list, setNewQuestion] = useState([]);
  const [correctAnswer, setNewCorrectAnswer] = useState(1);
  const [rules, setRules] = useState(0);
  const [installed, setInstalled] = useState(false);
  const [hasBeenPromptedToInstall, setHasBeenPromptedToInstall] =
    useState(false);
  const [deviceId, setDeviceId] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  /*useEffect(() => {
    console.log("Provider mounted");

    return () => {
      console.log("Provider unmounted");
    };
  }, []);*/

  return (
    <Context.Provider
      value={{
        count,
        setNumberAnswers,
        list,
        setNewQuestion,
        correctAnswer,
        setNewCorrectAnswer,
        rules,
        setRules,
        installed,
        setInstalled,
        hasBeenPromptedToInstall,
        setHasBeenPromptedToInstall,
        deviceId,
        setDeviceId,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
      }}
    >
      {children}
    </Context.Provider>
  );
};
